﻿import { GuiDetailGeneric } from "../../GuiDetailGeneric";

export class GuiDetailDirektaktion extends GuiDetailGeneric {

    constructor() {
        super("GuiDetailDirektaktion");
    }

    override attachEvents() {
        super.attachEvents();

        $("#btnAktionAddPosition").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickAktionAddPosition(e));
        $("#btnAktionAddKostenverteilung").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickAktionAddKostenverteilung(e));

        //$("div.erz-list div.erz-list-element > div:not(:has(input))").on("click", (e) => this.clickDetailRow(e));
        $("#VmDetail_Menge").on("keyup", () => this.onChangeMenge());
        $("#VmDetail_EinheitId").on("change", () => this.onChangeMenge());
        $("#VmDetail_UmrechnungsfaktorZuTonne").on("change", () => this.onChangeMenge());

        $("button.erz-btn-remove-kostenart").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickKostenartDelete(e));

    }

    clickKostenartDelete(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickKostenartDelete");
        e.preventDefault();
        // ID in Hidden Field übernehmen
        const aktionPositionId = $(e.currentTarget).closest("div.row.erz-list-element").data("id") as string;
        $("#mdlDeletePosition").modal("show");
        $("#mdlDeletePositionbtnDelete").on("click", (ev: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.clickKostenartDeleteConfirm(ev, aktionPositionId));

    }

    clickKostenartDeleteConfirm(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>, aktionPositionId: string) {
        this.log(`clickKostenartDeleteConfirm: ${aktionPositionId}`);
        $("#GuiAktion").val("DeletePosition");
        $("#AktionPositionId").val(aktionPositionId);

        if (!this.form.checkValidity()) {

            e.stopPropagation();
        } else {
            this.lock();
            // Submit form über Browser Button
        }
    }




    clickAktionAddPosition(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickAktionAddPosition");
        this.doAction(e);
    }

    clickAktionAddKostenverteilung(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) {
        this.log("clickAktionAddKostenverteilung");
        this.doAction(e);
    }

    onChangeMenge() {
        this.log("onChangeMenge");

        const txtMenge = $("#VmDetail_Menge").val() as string;
        const txtFaktor = $("#VmDetail_UmrechnungsfaktorZuTonne").val() as string;

        if (txtMenge == undefined || txtFaktor == undefined) return;

        const menge = Number(txtMenge.replace(",", "."));
        const faktor = Number(txtFaktor.replace(",", "."));


        const mengeInTonnen = menge * faktor;
        this.log(mengeInTonnen + "=" + menge + "*" + faktor);
        $("#VmDetail_MengeTonne").val(mengeInTonnen.toString().replace(".", ","));
    }
}